/**
 * @generated SignedSource<<1bf55fce67630dd6d44c4dc7bf00163b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SearchableSelectSeriesQuery$variables = {
  q: string;
  writableOnly: boolean;
};
export type SearchableSelectSeriesQuery$data = {
  readonly series: {
    readonly items?: ReadonlyArray<{
      readonly created: string | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly opencastId: any;
      readonly title: string;
    }>;
  };
};
export type SearchableSelectSeriesQuery = {
  response: SearchableSelectSeriesQuery$data;
  variables: SearchableSelectSeriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "q"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "writableOnly"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "q"
  },
  {
    "kind": "Variable",
    "name": "writableOnly",
    "variableName": "writableOnly"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchSeries",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "opencastId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SeriesSearchResults",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchableSelectSeriesQuery",
    "selections": [
      {
        "alias": "series",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "searchAllSeries",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SearchableSelectSeriesQuery",
    "selections": [
      {
        "alias": "series",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "searchAllSeries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51c651c16f28ac422b3374c530bd6eca",
    "id": null,
    "metadata": {},
    "name": "SearchableSelectSeriesQuery",
    "operationKind": "query",
    "text": "query SearchableSelectSeriesQuery(\n  $q: String!\n  $writableOnly: Boolean!\n) {\n  series: searchAllSeries(query: $q, writableOnly: $writableOnly) {\n    __typename\n    ... on SeriesSearchResults {\n      items {\n        id\n        opencastId\n        title\n        description\n        created\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ce69e78fbf8ae39586e9952fbc75968";

export default node;
